import { Tab, Tabs } from '@mui/material';
import { COLORS } from 'services/constants/colors';
import { COMMUNICATION_HISTORY_TABS, TCommunicationHistoryTab } from '../constants';
import { TCommunicationHistoryTabsProps } from './types';

export const CommunicationHistoryTabs = ({ value, onChange }: TCommunicationHistoryTabsProps) => {
	return (
		<Tabs
			value={value}
			onChange={(event, newValue: TCommunicationHistoryTab) => onChange(event, newValue)}
			sx={{
				minHeight: '20px',
				'& .MuiTabs-indicator': {
					backgroundColor: 'primary.main',
					height: '0',
				},
				'& .MuiButtonBase-root': {
					fontWeight: 'bold',
					color: COLORS.PRIMARY,
					opacity: 1,
				},
				'& .Mui-selected': {
					color: COLORS.PRIMARY,
					opacity: 0.5,
				},
			}}
		>
			<Tab
				value={COMMUNICATION_HISTORY_TABS.EMAIL}
				label="Email"
				sx={{ fontWeight: 'bold', p: '0 10px', minHeight: '20px' }}
			/>
			<Tab
				value={COMMUNICATION_HISTORY_TABS.SMS}
				label="SMS"
				sx={{ fontWeight: 'bold', p: '0 10px', minHeight: '20px' }}
			/>
		</Tabs>
	);
};
